import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import includes from 'lodash/includes';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import KeyRevealed from 'Components/Order/KeyRevealed';
import KeyRevealButton from 'Components/Order/KeyRevealButton';
import OrderDownloadsButton from 'Components/Order/OrderDownloadsButton';
import ZenvaRedeem from 'Components/Order/ZenvaRedeem';

function KeyReveal({
  game,
  orderStatus,
  orderID,
  bundleID,
  drm,
  emailConfirmed,
  voucher,
  setName,
  setKey,
  mysteryRevealed,
  setMysteryRevealed,
  setMysteryGameDetails,
  freeOrder,
}) {
  const isCoupon = includes(game.name.toLowerCase(), 'voucher:') || includes(game.name.toLowerCase(), 'coupon:') || get(game, 'drm.voucher') || game.type === 'voucher';
  const notComplete = orderStatus !== 'COMPLETE';

  if (notComplete) {
    return (
      <button className="btn btn-secondary btn-block" onClick={() => window.location.reload(true)}>
        <FormattedMessage id="reveal-key.processing.refresh" defaultMessage="Your order is processing. Click here to refresh" />
      </button>
    );
  }

  if (!emailConfirmed) {
    return (
      <div className="btn btn-secondary btn-block disabled">
        {game.noKeyDelivery ?
          <FormattedMessage id="reveal-key.verify-dl" defaultMessage="Please verify email to download" />
          :
          <FormattedMessage id="reveal-key.verify" defaultMessage="Please verify email to redeem key" />
        }
      </div>
    );
  }

  const isRevealed = !!game.key;
  const hasDownloads = game.downloads && game.downloads.length > 0;

  if (isRevealed) {
    return (
      <React.Fragment>
        <KeyRevealed
          game={game}
          drm={drm}
          bundleID={bundleID}
          isCoupon={isCoupon}
          voucher={voucher}
        />
        {drm === 'zenva' &&
          <ZenvaRedeem
            name={game.name}
            status={orderStatus}
            gameStatus={game.status}
            drmPlatform={drm}
            zenvaId={game.zenvaId ? game.zenvaId : ''}
          />
        }
        {hasDownloads &&
          <OrderDownloadsButton extras game={game} orderID={orderID} />
        }
      </React.Fragment>

    );
  }

  if (hasDownloads && game.noKeyDelivery) {
    return <OrderDownloadsButton game={game} drm={drm} orderID={orderID} />;
  }

  if (game.mystery && !mysteryRevealed) {
    return (<KeyRevealButton
      isMysteryReveal
      game={game}
      bundleID={bundleID}
      orderID={orderID}
      setName={setName}
      setMysteryGameDetails={setMysteryGameDetails}
      setMysteryRevealed={setMysteryRevealed}
      setKey={setKey}
    />);
  }

  return (<KeyRevealButton
    game={game}
    bundleID={bundleID}
    orderID={orderID}
    isCoupon={isCoupon}
    setName={setName}
    setMysteryGameDetails={setMysteryGameDetails}
    setMysteryRevealed={setMysteryRevealed}
    setKey={setKey}
    freeOrder={freeOrder}
  />);
}

KeyReveal.propTypes = {
  game: PropTypes.shape({}).isRequired,
  voucher: PropTypes.shape({}).isRequired,
  orderStatus: PropTypes.string.isRequired,
  orderID: PropTypes.string.isRequired,
  setName: PropTypes.func.isRequired,
  setKey: PropTypes.func.isRequired,
  setMysteryGameDetails: PropTypes.func.isRequired,
  setMysteryRevealed: PropTypes.func.isRequired,
  bundleID: PropTypes.string,
  drm: PropTypes.string,
  emailConfirmed: PropTypes.bool,
  mysteryRevealed: PropTypes.bool,
  freeOrder: PropTypes.bool,
};

KeyReveal.defaultProps = {
  bundleID: null,
  drm: '',
  emailConfirmed: false,
  mysteryRevealed: false,
  freeOrder: false,
};

const mapStateToProps = ({
  voucher,
}) => ({ voucher });

export default connect(mapStateToProps, null)(KeyReveal);
